// component para realizar comentario en una llamada

import { useState } from "react";
import { useTranslation } from "react-i18next";



export const CommentBox = ({ id = 0, onClose }) => {

  console.log("El id es ", id);

  const [t] = useTranslation("global");

  // state definition
  const [form, setForm] = useState({ comment: "" });

  // funcion para realizar el submit del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {

    } catch (err) {
      console.log(err)
    }
  };

  return (
    <form className="fade-animation" onSubmit={handleSubmit}>
      <textarea
        className="textarea-description"
        name="comment"
        value={form.comment}
        onChange={({ target }) => setForm((val) => ({ ...val, comment: target.value }))}
        placeholder={t("NewCallComp.comentario")} />
      <div className="row-flex flex-end gap-small">
        <button type="submit" className="btn-primary">
          Enviar
        </button>
        <button type="reset" className="btn-cancel" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </form>
  );
};